<!-- VIP 申请 -->
<template>
  <div class="menu-item-r">
    <div class="vip" v-loading="loading">
        <div class="vip-head">
            <div class="vip-head__title m-b-0">{{$t('vip.vip')}}</div>
            <!-- <div class="vip-head__subtitle">{{$t('vip.vipHeadSubTitle')}}</div> -->
        </div>
        <div class="vip-company">
            <div class="vip-company__title">{{$t('vip.company')}}</div>
            <div class="vip-company__body" v-if="info.visitor">
                <div class="vip-form__item">
                    <div class="vip-form__item-field">{{$t('vip.cName')}}</div>
                    <div class="vip-form__item-value">{{info.visitor.corporateName || '--'}}</div>
                </div>
                <div class="vip-form__item">
                    <div class="vip-form__item-field">{{$t('vip.cPhone')}}</div>
                    <div class="vip-form__item-value">{{info.visitor.telephone || '--'}}</div>
                </div>
                <div class="vip-form__item">
                    <div class="vip-form__item-field">{{$t('vip.cAddress')}}</div>
                    <div class="vip-form__item-value">{{info.visitor.address || '--'}}</div>
                </div>
                <div class="vip-form__item">
                    <div class="vip-form__item-field">{{$t('vip.cEmail')}}</div>
                    <div class="vip-form__item-value">{{info.visitor.emailHeadQuater || '--'}}</div>
                </div>
            </div>
        </div>

        <!-- 个人信息 -->
        <div class="vip-list" v-loading="loadingList">
            <div class="vip-list__title">{{$t('vip.vipInfo')}}</div>
            <div class="vip-list__tip v-tip">
                <div class="tip-title"><i class="el-icon-warning"></i> {{$t("Notice")}}</div>
                <div class="tip-text">{{$t('vip.vipInfoTip')}}</div>
            </div>
            <div class="vip-list__body">
                <el-table
                    :data="tableData"
                    border>
                    <el-table-column
                     :label="$t('vip.table.Passport_number')"
                     align="center"
                     prop="wechat">
                        <template slot-scope="scope">
                            <template v-if="editStatus">
                                <el-input v-model="scope.row.wechat" clearable :placeholder="$t('vip.table.Passport_number')" size="small"></el-input>
                            </template>
                            <template v-else>{{scope.row.wechat}}</template>
                        </template>
                     </el-table-column>
                    <el-table-column
                     :label="$t('vip.table.Passport_photo')"
                     align="center"
                     prop="workPass"
                     width="190">
                        <template slot-scope="scope">
                            <template v-if="!scope.row.workPass">
                                <el-button
                                    type="primary"
                                    size="small"
                                    icon="el-icon-circle-plus-outline"
                                    @click="uploadDialog('photo')"
                                    >{{ $t('vip.clickUpload') }}</el-button>
                            </template>
                            <template v-else>
                                <img v-lazy="scope.row.workPass" class="lazy-img-fadein imgWordPass" @click="uploadDialog('photo', scope.row)">
                            </template>
                        </template>
                     </el-table-column>
                    <el-table-column
                     :label="$t('vip.table.head')"
                     align="center"
                     prop="headImage">
                        <template slot-scope="scope">
                            <template v-if="!scope.row.headImage">
                                <el-button
                                    type="primary"
                                    size="small"
                                    icon="el-icon-circle-plus-outline"
                                    @click="uploadDialog('head')"
                                    >{{ $t('vip.clickUpload') }}</el-button>
                            </template>
                            <template v-else>
                                <img v-lazy="scope.row.headImage" class="lazy-img-fadein imgHeadImage" @click="uploadDialog('head', scope.row)">
                            </template>
                        </template>
                     </el-table-column>
                    <el-table-column
                     :label="$t('vip.table.Full_name')"
                     align="center"
                     prop="name"></el-table-column>
                    <el-table-column
                     :label="$t('vip.table.Sex')"
                     align="center"
                     prop="sex"
                     width="100"></el-table-column>
                    <el-table-column
                     :label="$t('vip.table.Status')"
                     align="center"
                     prop="status"
                     width="130">
                        <template slot-scope="scope">
                            <template v-if="scope.row.status === 'APPROVE'">
                                <span class="theme-tag theme-tag-small theme-icon-blue theme-tag-no-ml">{{$t('vip.statusText[3]')}}</span>
                            </template>
                            <template v-else-if="scope.row.status === 'DISAPPROVE'">
                                <span class="theme-tag theme-tag-error theme-tag-small theme-tag-no-ml">{{$t('vip.statusText[2]')}}</span>
                            </template>
                            <template v-else-if="scope.row.status === 'PENDING'">
                                <span class="theme-tag theme-tag-error theme-tag-small theme-tag-no-ml">{{$t('vip.statusText[1]')}}</span>
                            </template>
                            <template v-else>
                                <span class="theme-tag theme-tag-error theme-tag-small theme-tag-no-ml">{{$t('vip.statusText[0]')}}</span>
                            </template>
                        </template>
                     </el-table-column>
                    <el-table-column
                     v-if="vipAuditState"
                     :label="$t('vip.table.Download_invitation')"
                     align="center">
                        <el-button size='small' class="el-button--primary-empty font-size-13" @click="downVip">{{$t('vip.table.Download_invitation2')}}</el-button>
                     </el-table-column>
                </el-table>
                <div class="vip-list__body-todo" v-if="editStatus">
                    <el-button size='small' type="primary" class="font-size-13" @click="VipSubmit">{{$t('vip.table.submit')}}</el-button>
                </div>
            </div>
        </div>

        <!-- 图片上传弹框 -->
        <winDialog
            v-if="!vipAuditState"
            :dialogShow.sync="dShow"
            :title="title"
            :subTitle="subTitle"
            :sure="sure"
            :cancel="cancel">
            <template v-slot:bodyContent>
                <div class="upload-body">
                    <template v-if="currentDialog === 'photo'">
                        <DashUpload
                            :size="'vip-upload'"
                            :mediaUrl.sync="workPass"
                            :subTip="false"
                            :drag="true"
                            :tipText="$t('vip.uploadText')"
                            :tipImg="photo"
                            :maxImgSize="1"
                            :showTodo="false"
                        />
                    </template>
                    <template v-else>
                        <DashUpload
                            :size="'vip-upload vip-upload2'"
                            :mediaUrl.sync="headImage"
                            :subTip="false"
                            :drag="true"
                            :tipText="$t('vip.uploadText')"
                            :tipImg="head"
                            :maxImgSize="1"
                            :showTodo="false"
                        />
                    </template>
                    <div class="v-tip">
                        <div class="tip-title"><i class="el-icon-warning"></i> {{$t("Notice")}}</div>
                        <div class="tip-text">
                            <div>1、{{$t('vip.tip1')}}</div>
                            <div>2、{{$t('vip.tip2')}}</div>
                            <div>3、{{$t('vip.tip3')}}</div>
                        </div>
                    </div>
                </div>  
            </template>
            <template>
                
            </template>
        </winDialog>
        
        <!-- 下载VIP -->
        <winDialog
            ref="downVip"
            id="downVip"
            v-if="vipAuditState && info.visitor"
            :dialogShow.sync="dialogVIP"
            :title="vipTitle"
            :subTitle="vipSubTitle"
            :showFooter="false">
            <template v-slot:bodyContent>
                <div class="vip-card-body">
                    <div class="vid-card-block" ref="vidCardBlock">
                        <div class="vip-card">
                            <div class="vip-card__body">
                                <div class="vip-card__body-left">
                                    <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/logo.png" class="card-logo" />
                                    <div class="text">{{info.visitor.name}}</div>
                                    <div class="text2">{{info.visitor.corporateName}}</div>
                                    <img class="barcode" id="barcode" />
                                </div>
                                <div class="vip-card__body-right">
                                    <div class="text">VIP Card</div>
                                    <div class="img-head">
                                        <img src="../../assets/images/watermark.png" class="watermark" />
                                        <img :src="headImage" class="img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vip-card">
                            <div class="vip-card__body">
                                <div class="vip-card__body-top">
                                    <div class="vip-card__top-head">Notice</div>
                                    <ul>
                                        <li>Please present this card for entry when you visit Beijing International High-tech Exop</li>
                                        <li>This card is valid for tow years. It should be activated online once it's expired</li>
                                        <li>This card holder must comply with security inspection required by fair organizer who reserves the right of the change of admission</li>
                                    </ul>
                                </div>
                                <div class="vip-card__body-bottom">
                                    <span>www.jinhanfair.com</span>
                                    <span>info@jinhanfair.com</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vip-todo">
                        <el-button type="primary" class="no-radius" :loading="loadingVipStart" @click="startDownLoad('chart-download')">{{$t('vip.downloadStart')}}</el-button>
                    </div>
                </div>
            </template>
        </winDialog>
    </div>
  </div>
</template>

<script>
import { vipInfo, vipInsert } from '@/api'
import { mapGetters } from 'vuex'
import winDialog from '@/components/dialog/dialog'
import DashUpload from '@/components/DashUpload'
import photo from '@/assets/images/passport.png'
import head from '@/assets/images/actor.png'
import downCardMixin from '@/mixins/downCard.js'

export default {
  data () {
    // 这里存放数据
    return {
        dShow: false,
        title: '',
        subTitle: '',
        currentDialog: '',
        photo,
        head,
        workPass: '',
        headImage: '',
        loading: false,
        loadingList: false,
        loadingVipStart: false,
        tableData: [{
            wechat: '',
            workPass: '',
            headImage: '',
            sex: '',
            name: '',
            status: false
        }],
        vipTitle: '',
        vipSubTitle: '',
        dialogVIP: false
    }
  },
  mixins: [downCardMixin],
  components: {
    DashUpload,
    winDialog
  },
  computed: {
    ...mapGetters(['info', 'language']),
    vipAuditState() {
        return this.tableData[0]['status'] === 'APPROVE'
    },
    editStatus() {
        return this.tableData[0]['status'] === '' || this.tableData[0]['status'] === 'DISAPPROVE' || this.tableData[0]['status'] === 'PENDING'
    }
  },
  mounted () {
    this.pageInit()
  },
  methods: {
    initData(visitor) {
        this.$set(this.tableData, 0, {
            wechat: visitor.wechat || '',
            workPass: visitor.workPass ||'',
            headImage: visitor.headImage || '',
            sex: visitor.sex || this.$t("vip.sex"),
            name: visitor.name || '',
            status: visitor.vipAuditState || '',
            cardNumber: visitor.cardNumber
        })
        this.workPass = this.tableData[0]['workPass']
        this.headImage = this.tableData[0]['headImage']
    },
    pageInit() {
        this.loading = true
        let visitor = JSON.parse(JSON.stringify(this.info.visitor))
        // if (visitor.vipAuditState === 'APPROVE') {
        //     this.initData(visitor)
        //     this.loading = false
        // } else {
            vipInfo({languageType: this.language}).then(res => {
                return res.data
            }).then(res => {
                let data = res.data || null
                if (!data) {
                    data = visitor
                } else {
                    data.name = data.name || visitor.name
                }
                this.initData(data)
            }).finally(() => {
                this.loading = false 
            })
        // }
    },
    uploadDialog(name) {
        // 审核通过后，不可以修改
        if (!this.editStatus) return
        this.currentDialog = name
        if (name === 'photo') {
            this.title = this.$t('vip.photoTitle')
            this.subTitle = this.$t('vip.photoSubTitle')
        } else {
            this.title = this.$t('vip.headTitle')
            this.subTitle = this.$t('vip.headSubTitle')
        }
        this.dShow = true
    },
    sure(cb) {
        if (this.currentDialog === 'photo') {
            this.$set(this.tableData[0], 'workPass', this.workPass)
        } else {
            this.$set(this.tableData[0], 'headImage', this.headImage)
        }
        cb()
    },
    cancel(cb) {
        if (this.currentDialog === 'photo') {
            this.workPass = this.tableData[0]['workPass']
        } else {
            this.headImage = this.tableData[0]['headImage']
        }
        cb()
    },
    // 个人信息验证
    validateInfo() {
        let info = this.tableData[0]
        if (!info.wechat) {
            this.$notify.error({
                message: this.$t('vip.errMsg')
            })
            return false
        } else if (!/^[0-9a-zA-Z]{9,12}$/.test(info.wechat)) {
            this.$notify.error({
                message: this.$t('vip.errMsg1')
            })
            return false
        }
        if (!info.workPass) {
            this.$notify.error({
                message: this.$t('vip.errMsg2')
            })
            return false
        }
        if (!info.headImage) {
            this.$notify.error({
                message: this.$t('vip.errMsg3')
            })
            return false
        }

        return true
    },
    VipSubmit() {
        if (!this.validateInfo()) return
        this.loadingList = true
        let params = this.tableData[0]
        vipInsert({
            headImage: params['headImage'],
            workPass: params['workPass'],
            wechat: params['wechat'],
            name: params['name'],
            sex: params['sex'],
            languageType: this.language
        }).then(res => {
            let info = JSON.parse(JSON.stringify(this.info))
            let newInfo = {
                vipAuditState: 'PENDING'
            }
            if (info.visitor.vipWhiteList) {
                newInfo = {
                    vipAuditState: 'APPROVE',
                    headImage: params['headImage'],
                    workPass: params['workPass'],
                    wechat: params['wechat'],
                    cardNumber: res.data.data.exhibitionUserRegister.visitor.cardNumber,
                    vip: true
                }
            }
            info.visitor = Object.assign(info.visitor, newInfo)
            this.$set(this.tableData[0], 'status', newInfo.vipAuditState)
            this.$store.commit('SET_INFO', info)
        }).finally(() => {
            this.loadingList = false
        })
    },
    // VIP弹框
    downVip() {
        let card = this.tableData[0].cardNumber || this.info.visitor.cardNumber
        if (!card) {
            this.$notify.error({
                message: this.$t("vip.cardNumberEmpty")
            })
            return
        }
        this.vipTitle = this.$t("vip.table.Download_invitation2")
        this.vipSubTitle = this.$t('vip.vipSubTitle')
        this.dialogVIP = true        
        this.createJsbarcode(card)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/pages/vipCard'

.vip-todo {
    margin-top: 40px;
    text-align: center;

    >>> .el-button {
        width: 320px;
    }
}

.upload-body {
    padding: 36px 66px;
}

>>> .vip-upload {
    width: 100%;

    .picture-uploader {
        margin: 0 auto;
        width: 380px;
        height: 260px;

        .el-upload {
            padding: 30px;
            border-style: dashed
        }

        .picture {
            background: $color-gray-e5;
        }
    }

    .el-upload-dragger {
        width: 100%;
        height: 100%;
        border-radius: 0px;
        border: none;

        &>div {
            margin: 6px auto;
        }
    }

    .tipImg {
        margin: 0 auto;
        width: 160px;
        height: 160px;
        line-height: 160px;
        text-align: center;
    }
}

>>> .vip-upload2 {

    .picture-uploader {
        .el-upload {

            .picture {
                margin: 0 auto;
                width: 198px;
                border-radius: 50%;
            }
        }
    }

    .tipImg .tipPicture {
        display: inline-block;
        width: 100px;
        height: 100px;
    }
}

.vip {
    margin: 30px auto;
    padding-bottom: 70px;
    color: $color-gray-65;

    .vip-head,
    .vip-company,
    .vip-list {
        padding: 24px;
        background: $color-gray-fb;
    }

    .vip-company,
    .vip-list {
        margin-top: 16px;
    }

    .vip-head__title,
    .vip-company__title,
    .vip-list__title {
        margin-bottom: 8px;
        font-size: 16px;
        font-font-weight: 500;
        line-height 24px;
    }

    .vip-head__subtitle {
        font-size: 14px;
        line-height 20px;
    }

    .vip-company__body {
        margin-top: 24px;
    }

    .vip-form__item {
        max-width: 700px;
        padding: 8px 0;
        border-radius: 4px;
        background: $color-white;
        overflow: hidden;
        color: $color-gray-45;

        .vip-form__item-field {
            float: left;
            padding: 5px 16px;
            position: relative;
            line-height: 20px;
            font-size: 14px;

            &:before {
                content: '';
                position: absolute;
                right: 0;
                bottom: 0;
                height: 100%;
                width: 1px;
                background: $color-black-10;
            }
        }

        .vip-form__item-value {
            float: left;
            padding: 5px 24px;
            line-height: 20px;
            font-size: 16px;
            color: $color-gray-65;
        }

        & + .vip-form__item {
            margin-top: 16px;
        }
    }

    .vip-list__body {
        margin-top: 30px;

        >>> .el-table {
            .el-table__header-wrapper,
            .el-table__footer-wrapper {
                background: $color-gray-f1;
            }

            th {
                font-size: 14px;
                color: $color-gray-85;
                background: $color-gray-f1;
                .cell{
                    word-break: keep-all;
                }
            }

            tr {
                background: $color-gray-fb;

                td {
                    height: 195px;
                }
            }
        }

        .imgHeadImage {
            width: 115px;
            height: 115px;
            border-radius: 50%;
            object-fit: cover;
        }

        .imgWordPass {
            width: 165px;
            height: 115px;
            object-fit: contain;
        }
    }

    .vip-list__body-todo {
        margin-top: 24px;
        text-align: right;
    }
}

.version_en .vip-form__item-field {
    min-width: 163px;
}
</style>
